$.ready(function() {
	var messaging = game.messaging = $.div('messaging').appendTo(game.container);
	messaging.objects = {};
	
	messaging.add = function(key, object) {
		this.objects[key] = object;
		this.objects[key].appendTo(this);
		
		return this;
	};
	
	messaging.show = function(key) {
		if (this.objects[key] && !this.objects[key].hasClass('show')) {
			this.objects[key].addClass('show');
			this.objects[key].appendTo(this);
		}
		
		return this;
	};
	
	messaging.hide = function(key) {
		if (key) {
			if (this.objects[key] && this.objects[key].hasClass('show')) {
				this.objects[key].removeClass('show');
				this.objects[key].reinsert();
			}
			
			return this;
		}
		
		for (key in this.objects) {
			if (this.objects[key].hasClass('show')) {
				this.objects[key].removeClass('show');
				this.objects[key].reinsert();
			}
		}
		
		return this;
	};
	
	/* Logo */
	{
		game.logo = $.div('logo');
		messaging.add('logo', game.logo);
	}
	
	/* Pays */
	{
		var pays = game.pays.messaging = $.div().addClass('pays');
		messaging.add('pays', pays);
	}
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/container-messaging.js
 **/